"use client";
import { OnDemandChatBot } from "ondemand-react-chat-bot";
import React from "react";

const Chatbot = () => {
    return process.env.NEXT_PUBLIC_ENV != "production" ? (
        <OnDemandChatBot
            apiKey={process.env.NEXT_PUBLIC_CHATBOT_ID}
            botId={process.env.NEXT_PUBLIC_CHATBOT_KEY}
        />
    ) : null;
};

export default Chatbot;
